import * as React from 'react';
import { Link } from 'react-router-dom';
import { MdOutlineAutoAwesome } from 'react-icons/md';
import { isValidUrl } from 'app/infrastructure/validation/url';
import { getAiChatBaseUrl } from 'app/infrastructure/hosting';
import { urlToAiChat } from 'app/infrastructure/js/url-to-ai-chat';
import styles from '../mobile-nav.scss';

export const AiChatMenuItem = ({ aiChatAssistantAccessInfo, instanceInfo, translation, onClick }) =>
  aiChatAssistantAccessInfo?.aiAdvisor
  && isValidUrl(urlToAiChat(getAiChatBaseUrl(), instanceInfo))
  && (
    <li onClick={onClick}>
      <Link
        className="list-group-item"
        to={urlToAiChat(getAiChatBaseUrl(), instanceInfo)}
        target="_blank"
        rel="noreferrer">
        <MdOutlineAutoAwesome id="nav-ai-chat-icon" className={styles.navItemIcon} />
        <span className={styles.navItemText}>{translation.ai_chat_title}</span>
      </Link>
    </li>
  );
